import {
  Component, Input, HostBinding, ContentChildren, QueryList, Output, EventEmitter, AfterContentInit, OnInit, forwardRef
} from '@angular/core';
import { RouterLink, Router, NavigationEnd } from '@angular/router';

import { PersonaProviderStore } from '@sondermind/data-access/provider-facing/persona-provider';
import { SondermindApplicationService } from '@sondermind/data-access/sondermind-app-service';
import { IconColors, IconSizes, IconUsageTypes } from '@sondermind/iris/icon';

@Component({
  selector: 'sondermind-side-nav-menu-item',
  templateUrl: './side-nav-menu-item.component.html',
  standalone: false
})
export class SideNavMenuItemComponent implements OnInit, AfterContentInit {
  // Menu items should have either a badge or a message, not both
  // MessageStyle corresponds to values in _side-nav.scss
  @Input() badge: string;
  @Input() message: string;
  @Input() @HostBinding('attr.messageStyle')
    messageStyle: string;

  @Input() label: string;
  @Input() status: string;

  @Input() @HostBinding('attr.icon')
    workIcon: string = '';

  @Input() @HostBinding('attr.icon')
    statusIcon: string = '';

  @Input() showSubMenu: boolean = false;
  @Output() itemClicked = new EventEmitter<any>();

  @Input() @HostBinding('attr.iconOnRight')
    iconOnRight: boolean = false;

  @Input() @HostBinding('attr.size')
    size: string = 'main';

  @Input() @HostBinding('attr.icon')
    icon: string = '';

  @Input() @HostBinding('attr.svg')
    svg: boolean = false;

  @Input() isAwareness: boolean = false;
  @Input() isActive: boolean = false; // used to get value of routerlinkactive.isactive
  @Input() isFooter: boolean = false;
  @ContentChildren(forwardRef(() => SideNavMenuItemComponent)) subMenu: QueryList<SideNavMenuItemComponent>;
  @ContentChildren(RouterLink) subMenuLinks: QueryList<RouterLink>;

  @Input() disableToggle: boolean;

  private personaProviderId: number;

  iconColors = IconColors;
  iconSizes = IconSizes;
  iconUsageTypes = IconUsageTypes;

  constructor(
    private router: Router,
    private personaProviderStore: PersonaProviderStore,
    public appService: SondermindApplicationService,
  ) {
  }

  ngOnInit() {
    this.personaProviderStore.providerProfile$.subscribe((profile) => {
      if (profile?.id) {
        this.appService.acceptingClients = profile.acceptingClients;
        this.personaProviderId = profile.id;
      }
    });
  }

  ngAfterContentInit() {
    let subLink = this.subMenuLinks.find((item) => this.router.isActive(item.urlTree, false));
    this.showSubMenu = subLink != null;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        subLink = this.subMenuLinks.find((item) => this.router.isActive(item.urlTree, false));
        this.showSubMenu = subLink != null;
      }
    });
  }

  updateAvailabilityStatus(availability: boolean): void {
    this.personaProviderStore.toggleSavingAvailability(true);
    this.personaProviderStore.updateAvailability(availability, this.personaProviderId);
  }

  handleInteraction(): void {
    this.showSubMenu = !this.showSubMenu;
    this.itemClicked.emit(this.showSubMenu);
  }

  acceptingToggleClick(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  get haveIcon(): boolean {
    return this.icon && !this.svg;
  }

  get haveSvg(): boolean {
    return this.icon && this.svg;
  }
}
